import request from '@/utils/request'
import { AxiosProgressEvent } from 'axios'
import { isArray } from 'lodash'

export const postUpload = async (data: File) => {
  const formData = new FormData()
  formData.append('file', data)
  return await request.post('/system/document-stores/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// upload single file
export const postUploadSingle = async (data: File, callback?: (progressEvent: AxiosProgressEvent) => void) => {
  const formData = new FormData()
  formData.append('file', data)
  return await request.post('/v1/document-stores/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: callback
  })
}

// Download file
export const getDownLoadFile = async (id: string | number) => {
  return await request.get(`/v1/document-stores/${id}/download`, {
    responseType: 'blob'
  })
}

// Tìm kiếm văn bản điều hành đến
export const getExecutiveDocumentsArrive = async (params?: string, chucDanhId?: number) => {
  return await request.get(`/v1/van-ban-dieu-hanh/van-ban-den?${params}`, {
    headers: {
      'chuc-danh-id': chucDanhId
    }
  })
}

// Tìm kiếm văn bản điều hành đi
export const getExecutiveDocumentsGo = async (params: string, chucDanhId?: number) => {
  return await request.get(`/v1/van-ban-dieu-hanh/van-ban-di?${params}`, {
    headers: {
      'chuc-danh-id': chucDanhId
    }
  })
}

// Lấy file đính kèm văn bản điều hành
export const getTheExecutiveDocumentAttachment = async (data: any) => {
  return await request.patch(`/v1/van-ban-dieu-hanh/download-file-dinh-kem`, data, {
    headers: {
      'chuc-danh-id': 1
    }
  })
}

// Combobox units
export const getUnits = async () => {
  return await request.get(`/v1/units/list`)
}

// Combobox đối tượng thanh tra
export const getDoiTuongThanhTra = async () => {
  return await request.get(`/v1/doi-tuong-thanh-tra?limit=${9999}`)
}

// Combobox lĩnh vực vi phạm
export const getLinhVucViPham = async () => {
  return await request.get(`/v1/linh-vuc-vi-pham?limit=${9999}`)
}

// Combobox loại kết luận thanh tra
export const getLoaiKetLuanThanhTra = async () => {
  return await request.get(`/v1/loai-ket-luan-thanh-tra/list`)
}

// Combobox loại chi phí
export const getLoaiChiPhi = async () => {
  return await request.get(`/v1/loai-chi-phi?limit=${9999}`)
}

// Combobox loại nguồn vốn
export const getLoaiNguonVon = async () => {
  return await request.get(`/v1/loai-nguon-von?limit=${9999}`)
}

// Combobox loại kiểm toán
export const getLoaiKiemToan = async () => {
  return await request.get(`/v1/loai-kiem-toan?limit=${9999}`)
}

// Combobox tên dự án
export const getTenDuAn = async () => {
  return await request.get(`/v1/ten-du-an?limit=${9999}`)
}

// Combobox Quận huyện
export const getQuanHuyen = async () => {
  return await request.get(`/v1/area/list?type=${1}`)
}

export const getHinhThucXuLy = async () => {
  return await request.get(`/v1/hinh-thuc-xu-ly?limit=${9999}`)
}

export const getHinhThucKienNghi = async () => {
  return await request.get(`/v1/hinh-thuc-kien-nghi?limit=${9999}`)
}

// Combobox phường xã
export const getPhuongXa = async (id: string) => {
  return await request.get(`/v1/area/list?type=${2}&id=${id}`)
}

// Combobox Nhóm đối tượng thanh tra
export const getNhomDoiTuongThanhTra = async () => {
  return await request.get(`/v1/nhom-doi-tuong-thanh-tra?limit=${9999}`)
}

// Get file
export const getFile = async (id: number) => {
  return await request.get(`/api/files/info/${id}`, {
    headers: { upload_file: true }
  })
}

// Lấy thông tin điều kiện lọc dữ liệu theo id cột
export const getOperatorsByColumnId = async (id: number) => {
  return await request.get(`/dynamic-reports/columns/${id}/operators`)
}

// Upload file
export const uploadFile = async (data: any) => {
  const formData = new FormData()

  if (isArray(data)) {
    data.forEach((file) => {
      formData.append('files', file)
    })
  } else {
    formData.append('files', data)
  }

  return await request.post('/api/files/upload', formData, {
    headers: { upload_file: true }
  })
}

// Tải biểu mẫu
export const downloadForm = async (type: 'THANH_TRA' | 'KIEN_NGHI_KTNN') => {
  return await request.get(`/v1/ket-luan/export-templete?type=${type}`, {
    responseType: 'blob'
  })
}

export const getLoaiVanBanEnum = async () => {
  return await request.get(`/v1/don-vi-thuc-hien-kien-nghi-ktnn/getLoaiVanBanEnum`)
}
